document.addEventListener('DOMContentLoaded', () => {
    initDynamicSearchInputs();
});


$('.ab854__search__textbox').val('Sunday brunch, classic but not conservative, not trendy');

$('.js-clear-search').on('click', function () {
    $('.ab854__search__textbox').val('');
    $(this).hide();
})

function initStickyCloseButtonObserver() {
    const trigger = document.querySelector('.js-sticky-trigger');
    const topFixed = document.querySelector('.js-top-fixed');
    const closeButton = topFixed?.querySelector('.js-modal-close');

    if (!trigger || !topFixed || !closeButton) return;

    const observer = new IntersectionObserver(
        ([entry]) => {
            if (!entry.isIntersecting) {
                topFixed.classList.add('ab854__top-button--fixed');
                closeButton.classList.remove('u-margin-b--xl');
            } else {
                topFixed.classList.remove('ab854__top-button--fixed');
                closeButton.classList.add('u-margin-b--xl');
            }
        },
        { root: null, threshold: 0 }
    );

    observer.observe(trigger);
}


function initDynamicSearchInputs() {
    const inputs = document.querySelectorAll('input.ab854__search__textbox');

    inputs.forEach(input => {
        if (input.dataset.dynamicBound) return;

        input.dataset.dynamicBound = 'true';
        const wrapper = input.closest('.ab854__search');

        input.addEventListener('focus', function handleFocus(event) {
            const originalInput = event.target;
            const wrapper = originalInput.closest('.ab854__search');

            // Create a wrapper for textarea + clear button
            const container = document.createElement('div');
            container.style.position = 'relative';
            container.style.width = originalInput.offsetWidth + 'px';

            // Create textarea
            const textarea = document.createElement('textarea');
            textarea.className = originalInput.className;
            textarea.value = originalInput.value;
            textarea.placeholder = originalInput.placeholder;
            textarea.setAttribute('rows', '1');
            textarea.style.overflow = 'hidden';
            textarea.style.whiteSpace = 'normal';
            textarea.style.boxSizing = 'border-box';
            textarea.style.width = '100%';
            textarea.style.paddingRight = '2.5rem'; // Make space for the button

            // Create clear button
            const clearBtn = document.createElement('button');
            clearBtn.setAttribute('type', 'button');
            clearBtn.className = 'ab854__clear-search';
            clearBtn.innerHTML = '&times;';
            clearBtn.style.position = 'absolute';
            clearBtn.style.right = '0.6rem';
            clearBtn.style.top = '50%';
            clearBtn.style.transform = 'translateY(-50%)';
            clearBtn.style.background = 'transparent';
            clearBtn.style.border = 'none';
            clearBtn.style.fontSize = '1.5rem';
            clearBtn.style.color = '#333';
            clearBtn.style.cursor = 'pointer';
            clearBtn.style.lineHeight = '1';
            clearBtn.style.padding = '0';

            clearBtn.addEventListener('mousedown', (e) => {
                // Prevent textarea from losing focus before click logic runs
                e.preventDefault();
            });

            clearBtn.addEventListener('click', (e) => {
                e.preventDefault();
                textarea.value = '';
                textarea.style.height = 'auto';
                textarea.style.height = textarea.scrollHeight + 20 + 'px';
                textarea.focus(); // re-focus to keep textarea active
            });


            container.appendChild(textarea);
            container.appendChild(clearBtn);
            wrapper.replaceChild(container, originalInput);

            // Auto-expand textarea height
            textarea.style.height = 'auto';
            textarea.style.height = textarea.scrollHeight + 20 + 'px';
            textarea.focus();

            textarea.addEventListener('input', () => {
                textarea.style.height = 'auto';
                textarea.style.height = textarea.scrollHeight + 20 + 'px';
            });

            textarea.addEventListener('blur', () => {
                const newInput = document.createElement('input');
                newInput.type = 'text';
                newInput.className = textarea.className;
                newInput.value = textarea.value;
                newInput.placeholder = textarea.placeholder;
                newInput.dataset.dynamicBound = 'true';

                wrapper.replaceChild(newInput, container);
                newInput.addEventListener('focus', handleFocus);
            });
        });
    });
}


window.selectedFilterIdsMobile = new Set();

$('.smart-filters').on('click', function () {
    $.modal({
        url: 'smartFiltersModalMobile.html',
        type: 'full',
        triggerOpen: true,
        triggerElement: $(this),
        onComplete: function () {

            initStickyCloseButtonObserver();

            $.ajax({
                url: 'smartFilterModalQuestionsMobile.html',
                success: function (response) {
                    const $questionContainer = $('.generated__questions');
                    $questionContainer.append(response);
                    $('.loading').hide();

                    $questionContainer.find('input[type="checkbox"]').each(function () {
                        if (selectedFilterIdsMobile.has(this.id)) {
                            this.checked = true;
                        }
                    });

                    initDynamicSearchInputs();

                    generatePills($questionContainer);

                    function generatePills($container) {
                        const $pillWrapper = $('.js-selected-pills').empty().removeClass('u-hide');
                        const $refineText = $('.js-refine-label');
                        const selected = $container.find('input[type="checkbox"]:checked');

                        if (!selected.length) {
                            $pillWrapper.addClass('u-hide');
                            $refineText.removeClass('u-hide');
                            return;
                        }

                        // Create <ul> for pills
                        const $ul = $('<ul class="size-options u-margin-b--none" />');

                        selected.each(function () {
                            const input = this;
                            const labelText = $container.find(`label[for="${input.id}"] .push-button__copy`).text().trim();

                            const $li = $('<li />');
                            const $pill = $(`<div class="pill-button pill-button--light-grey"><span>${labelText}</span></div>`);
                            const $close = $(`
            <button type="button" class="u-margin-l--xs">
                <span class="icon icon--x">
                    <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation">
                        <path d="M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28 4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8 9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z"></path>
                    </svg>
                    <div class="u-screen-reader">Remove Filter</div>
                </span>
            </button>
        `);

                            $close.on('click', function () {
                                input.checked = false;
                                $li.remove();
                                generatePills($container);
                            });

                            $pill.append($close);
                            $li.append($pill);
                            $ul.append($li);
                        });

                        // Add Clear Filters pill
                        const $clearLi = $('<li class="horizontal-scroll__item" />');
                        const $clearBtn = $('<button class="pill-button pill-button--black u-white-space--nowrap">Clear Filters</button>');

                        $clearBtn.on('click', function () {
                            $container.find('input[type="checkbox"]').prop('checked', false);
                            generatePills($container);
                        });

                        $clearLi.append($clearBtn);
                        $ul.append($clearLi);

                        $pillWrapper.append($ul);
                        $refineText.addClass('u-hide');
                    }


                    //Update button count + store selections on Apply
                    document.querySelector('.submit-questions')?.addEventListener('click', function () {
                        const checkedInputs = $questionContainer.find('input[type="checkbox"]:checked');
                        selectedFilterIdsMobile = new Set();

                        checkedInputs.each(function () {
                            selectedFilterIdsMobile.add(this.id);
                        });

                        const checkedCount = checkedInputs.length;
                        const $smartFiltersBtn = $('.smart-filters');
                        $smartFiltersBtn.text(checkedCount > 0 ? `Smart Filters (${checkedCount})` : 'Smart Filter');
                    });
                }
            });
        }


    });
});


// WEBPACK FOOTER //
// ./src/scripts/modules/abtest/smart-filters.js